import { GQLJobSummary } from '@jewelutions/core-crm-server-api-client-domain';
import { Grid, Typography } from '@material-ui/core';
import React, { forwardRef } from 'react';
import { useStyles } from './JobSummary.style';

interface IProps {
  jobSummary: GQLJobSummary;
  ref?: any;
}
export const JobSummary: React.FC<IProps> = forwardRef((props, ref) => {
  const classes = useStyles();

  const createdAt =
    props.jobSummary && props.jobSummary.createdAt ? new Date(Date.parse(props.jobSummary.createdAt)) : null;
  const startedAt =
    props.jobSummary && props.jobSummary.startedAt ? new Date(Date.parse(props.jobSummary.startedAt)) : null;
  const scheduledToStartAt =
    props.jobSummary && props.jobSummary.scheduledToStartAt
      ? new Date(Date.parse(props.jobSummary.scheduledToStartAt))
      : null;
  const finishedAt =
    props.jobSummary && props.jobSummary.finishedAt
      ? new Date(Date.parse(props.jobSummary.finishedAt))
      : null;

  return (
    <Grid container direction="column">
      <Grid item>
        <Typography>{props.jobSummary ? props.jobSummary.state : 'No job available'}</Typography>
        {props.jobSummary && (
          <React.Fragment>
            <Typography>
              Created at {createdAt?.toLocaleDateString()} - {createdAt?.toLocaleTimeString()}
            </Typography>
            <Typography>
              Scheduled at {scheduledToStartAt?.toLocaleDateString()} -{' '}
              {scheduledToStartAt?.toLocaleTimeString()}
            </Typography>
            {startedAt && <Typography>Started at {startedAt!.toLocaleDateString()}</Typography>}
            {!startedAt && <Typography>Not yet started. Will start soon.</Typography>}
            {finishedAt && <Typography>Finished at {finishedAt!.toLocaleDateString()}</Typography>}
          </React.Fragment>
        )}
      </Grid>
    </Grid>
  );
});
